import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { AssignedDriverDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

const routesTypes = [
  {
    value: 0,
    label: "Toate",
  },
  { value: 1, label: "Rute locale" },
  { value: 2, label: "Rute internod" },
  { value: 3, label: "Ambele rute" },
  { value: 4, label: "Rute finalizate" },
];

export const assignedDriversDataTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nume",
    value: "nume",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Prenume",
    value: "prenume",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Ruta locala",
    value: "ruta",
    minW: 125,
  },
  {
    label: "Ruta internod",
    value: "type",
    minW: 200,
    withFilter: routesTypes,
  },
  {
    label: "Nr. Auto",
    value: "nrauto",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Data inceput",
    value: "sofer_data_start",
    minW: 125,
  },
  {
    label: "Data sfarsit",
    value: "sofer_data_stop",
    minW: 125,
  },
];

export const getAssignedDriversTableData = (
  data: AssignedDriverDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_sofer_rute,
      crudData: item,
      data: [
        {
          title: item.nume,
        },
        {
          title: item.prenume,
        },
        {
          title: item.ruta ?? "-",
        },
        {
          title: item.id_ruta_intranod
            ? `${item.nod_start} -> ${item.nod_destinatie}`
            : "-",
        },
        {
          title: item.nrauto ?? "-",
        },
        {
          title: getDateAndTime(item.sofer_data_start, "-"),
        },
        {
          title: getDateAndTime(item.sofer_data_stop, "-"),
        },
      ],
    };
  });
